/* eslint-disable  */

import React, { useCallback, useEffect, useState } from 'react'
import { Button, Divider, Grid, TextField, Typography } from '@material-ui/core'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { Autocomplete } from '@mui/material'
import dayjs from 'dayjs'
import { useGetDynamicRenewals } from '~/renewals'
import { useProperties } from '~/properties'
import { sortPricing } from './whips'
import Dayjs from 'dayjs'
import {sortBy} from 'lodash'
import { useUpdateWhip } from '~/whips'
import { api } from '#/apis';

const WhipsUpdateForm = props => {
	const { setModalOpen, whipValues } = props
	const [formValues, setFormValues] = useState({...whipValues, new_id: whipValues.id})
	const [enabled, setEnabled] = useState(false)
	const { data: properties } = useProperties()

	const { mutate: updateWhip } = useUpdateWhip()


	useEffect(() => {
		validateForm()
		return () => {}
	}, [])

	useEffect(() => {
		return () => {}
	}, [properties])

	const validateForm = () => {
		if (
			formValues?.prop_name &&
			// formValues?.unit_type_name &&
			formValues?.status &&
			formValues?.id
		) {
			setEnabled(true)
		}
	}

	const handleChange = e => {
		const { name, value } = e.target

		setFormValues(prevState => ({
			...prevState,
			[name]: value,
		}))

		validateForm()
	}

	const handleSubmit = async event => {
		// console.log('herro')
		// console.log(formValues)
		updateWhip(formValues)
	}

	return (
		<form
			style={{
				marginTop: '20px',
				marginBottom: '20px',
			}}
			xs={6}
		>
			{formValues && (
				<div>
					<Typography
						variant='h5'
						children={` Property: ${formValues?.prop_name}`}
					/>

					<Typography
						variant='subtitle1'
						children={` Unit Number: ${
							formValues?.unit_number || '-'
						}`}
					/>
			
				</div>
			)}

			<Divider style={{ marginTop: '5px', marginBottom: '20px' }} />

			<TextField
				name='new_id'
				value={formValues?.new_id || ''}
				label='Whip ID'
				fullWidth
				onChange={handleChange}
			/>

			<TextField
				name='applicants'
				value={formValues?.applicants || ''}
				label='Applicants'
				fullWidth
				onChange={handleChange}
			/>

			<Autocomplete
				name='status'
				fullWidth
				options={['pending', 'verified', 'rejected', 'resident_opt_out']}
				renderInput={params => (
					<TextField {...params} required label='Status' />
				)}
				value={formValues?.status || []}
				onChange={(e, value) => {
					handleChange({
						target: {
							name: 'status',
							value: value || '',
						},
					})
				}}
			/>

			<TextField
				name='comments'
				value={formValues?.comments || ''}
				label='Comments'
				fullWidth
				onChange={handleChange}
			/>

			<Grid
				container
				justifyContent='flex-end'
				spacing={3}
				style={{ marginTop: '10px' }}
			>
				<Grid item>
					<Button
						onClick={() => {
							setModalOpen(false)
						}}
						children='Cancel'
						variant='contained'
					/>
				</Grid>
				<Grid item>
					<Button
						variant='contained'
						color='primary'
						type='submit'
						disabled={!enabled}
						onClick={handleSubmit}
						children='Submit'
					/>
				</Grid>
			</Grid>
		</form>
	)
}

export default WhipsUpdateForm
